/* unplugin-vue-components disabled */import { render } from "./DiceRender.vue?vue&type=template&id=72b021f4&scoped=true"
import script from "./DiceRender.vue?vue&type=script&lang=js"
export * from "./DiceRender.vue?vue&type=script&lang=js"

import "./DiceRender.vue?vue&type=style&index=0&id=72b021f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b021f4"]])

export default __exports__